export default [
  {
    path: '/work/:workTab?',
    component: () => import('./RouteWork'),
  },
];
